//
//  SDKCodeLanguage.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Source type enum
export var CodeLanguage;
(function (CodeLanguage) {
    CodeLanguage["angular"] = "Angular";
    CodeLanguage["bash"] = "Bash";
    CodeLanguage["c"] = "C";
    CodeLanguage["cpp"] = "Cpp";
    CodeLanguage["css"] = "CSS";
    CodeLanguage["csharp"] = "Csharp";
    CodeLanguage["dart"] = "Dart";
    CodeLanguage["handlebars"] = "Handlebars";
    CodeLanguage["html"] = "HTML";
    CodeLanguage["java"] = "Java";
    CodeLanguage["javascript"] = "Javascript";
    CodeLanguage["json"] = "JSON";
    CodeLanguage["reactJsx"] = "ReactJSX";
    CodeLanguage["reactTsx"] = "ReactTSX";
    CodeLanguage["kotlin"] = "Kotlin";
    CodeLanguage["lua"] = "Lua";
    CodeLanguage["markdown"] = "Markdown";
    CodeLanguage["objectiveC"] = "ObjectiveC";
    CodeLanguage["php"] = "PHP";
    CodeLanguage["plain"] = "Plain";
    CodeLanguage["python"] = "Python";
    CodeLanguage["ruby"] = "Ruby";
    CodeLanguage["rust"] = "Rust";
    CodeLanguage["sass"] = "Sass";
    CodeLanguage["scss"] = "SCSS";
    CodeLanguage["svelte"] = "Svelte";
    CodeLanguage["swift"] = "Swift";
    CodeLanguage["twig"] = "Twig";
    CodeLanguage["typescript"] = "Typescript";
    CodeLanguage["vue"] = "Vue";
    CodeLanguage["xml"] = "XML";
    CodeLanguage["yaml"] = "YAML";
})(CodeLanguage || (CodeLanguage = {}));
